import { useState, useEffect } from "react";
import { legalRedirects, MainRoutes } from "@router/route-params";

/**
 * Resolves legal-document redirects based on the current URL.
 *
 * @returns Object with route classification and the resolved redirect target.
 */
export function useLegalRedirect(): {
  isLegalRoute: boolean;
  targetUrl: string | null;
} {
  const [targetUrl, setTargetUrl] = useState<string | null>(null);
  const isLegalRoute = window.location.pathname.startsWith(
    `/${MainRoutes.legal}`
  );

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const matchingRedirect = Object.values(legalRedirects).find(
        (redirect) => `#${redirect.path}` === hash
      );

      if (matchingRedirect) {
        setTargetUrl(matchingRedirect.targetUrl);
        return;
      }
    }

    // Default fallback if no hash match is found
    setTargetUrl(legalRedirects.termsOfService.targetUrl);
  }, []);

  return { isLegalRoute, targetUrl };
}
